import HomePage from '../pages/HomePage'
import Logout from '../pages/Logout'
import LoginError from '../pages/LoginError'

export class Route {
    path: string
    component: any
    _private: boolean
    children: Route[]
    redirectTo: string
    exact: boolean
    props?: any

    constructor(
        path: string,
        component: any,
        _private: boolean,
        redirectTo: string,
        children: Route[],
        exact?: boolean,
        props?: any
    ) {
        this.path = path
        this.component = component
        this._private = _private
        this.children = children
        this.redirectTo = redirectTo
        this.exact = exact ? exact : false
        this.props = props ? props : undefined
    }

    static DefaultRoute() {
        return new Route('/', HomePage, false, null, [], true)
    }

    static LogoutRoute() {
        return new Route('/logout', Logout, false, null, [], true)
    }

    static LoginError() {
        return new Route(
            '/login_error:error_id?',
            LoginError,
            false,
            null,
            [],
            true
        )
    }
}
